import { useState, useEffect } from 'react';
import FormularioActa from '../../components/actas/FormularioActa';
import funcionalidadesApiService from '../../services/http/funcionalidadesApiService';

const ImportarNotas = () => {
  const [lmsActivo, setLmsActivo] = useState(null);

  useEffect(() => {
    const fetchLms = async () => {
      try {
        const response = await funcionalidadesApiService.obtenerLmsActivo();
        setLmsActivo(response.lms || null);
      } catch {
        setLmsActivo(null);
      }
    };
    fetchLms();
  }, []);

  const lmsLabel = lmsActivo === 'moodle' ? 'Moodle' : 'D2L';

  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Importar notas</h1>
        <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
          Importación de notas desde {lmsLabel}
        </p>
      </div>
      <FormularioActa />
    </div>
  );
};

export default ImportarNotas;
